import type { UpdateProduitOrganisationMutationRequest, UpdateProduitOrganisationMutationResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { produitsOrganisation } from '~/msw/mocks/produitOrganisation'

export function updateProduitOrganisationHandler() {
  return http.patch<
    { officeOid: string, id: string },
    UpdateProduitOrganisationMutationRequest,
    UpdateProduitOrganisationMutationResponse
  >('http://localhost:3000/api/v1/produits-organisation/:officeOid/:id', async ({ params, request }) => {
    const produit = produitsOrganisation.find(p => String(p.id) === params.id)
    if (!produit) {
      return HttpResponse.json(null, { status: 404 })
    }
    const body = await request.json()
    produit.diffuseurExterneOrganisationId = body.diffuseurExterneOrganisationId
    return HttpResponse.json(produit)
  })
}

// Variante « scenario » de l'endpoint : la mise à jour échoue (HTTP 500).
// Branchée via ?scenario=updateError et composée dans ~/msw/scenarios.ts.
export function updateProduitOrganisationErrorHandler() {
  return http.patch(
    'http://localhost:3000/api/v1/produits-organisation/:officeOid/:id',
    () => HttpResponse.json({ message: 'Échec de la mise à jour' }, { status: 500 }),
  )
}
